import readRequiredStringEnv from './services/readRequiredStringEnv';

export enum StoreType {
  CONTENT_ONLY = 'contentOnly',
  DISPLAY_ONLY = 'displayOnly',
  SHOP = 'shop'
}

const parseStoreType = (value: string): StoreType => {
  switch (value) {
    case StoreType.CONTENT_ONLY:
    case StoreType.DISPLAY_ONLY:
    case StoreType.SHOP:
      return value;
    default:
      throw new Error(
        `Unknown NEXT_PUBLIC_STORE_TYPE value "${value}". Expected one of: ${StoreType.SHOP}, ${StoreType.DISPLAY_ONLY}, ${StoreType.CONTENT_ONLY}.`
      );
  }
};

const storeType: StoreType = parseStoreType(
  readRequiredStringEnv(process.env.NEXT_PUBLIC_STORE_TYPE, 'NEXT_PUBLIC_STORE_TYPE')
);

export const isContentOrDisplayStoreType: boolean =
  storeType === StoreType.CONTENT_ONLY || storeType === StoreType.DISPLAY_ONLY;

export const isContentOnlyStoreType: boolean = storeType === StoreType.CONTENT_ONLY;

export const isDisplayOrShopStoreType: boolean =
  storeType === StoreType.DISPLAY_ONLY || storeType === StoreType.SHOP;

export const isShopStoreType: boolean = storeType === StoreType.SHOP;

export default storeType;
